module.exports = __webpack_public_path__ + "img/img05.d53b41fa.png";